<template>
  <page-wrapper
    :title="'ใบแจ้งหนี้'"
    :noPadBtm="true"
  >
    <div class="content-wrapper" v-if="isShowDetails">
      <!-- Admin -->
      <div class="sub-title admin" v-if="isRuejaiPartnerAdmin">
        <div class="text-wrapper">
          <div class="title">รายละเอียดใบแจ้งหนี้</div>
          <div class="provider">
            {{ `ผู้ให้บริการ : ${detailsResult.providerName}` }}
          </div>
        </div>
        <div class="button-wrapper admin" v-if="isShowAdminButtonSection">
          <button class="button cancel" @click="isShowRejectInvoiceSection = true">
            <img src="/static/icons/supplier-red-close-icon.svg" />ไม่อนุมัติ
          </button>
          <button class="button confirm" @click="handleUpdateInvoiceStatus(invoiceStatus)">
            <img src="/static/icons/supplier-correct-icon.svg"/>{{ updateStatusButtonText }}
          </button>
        </div>
        <div class="button-wrapper admin" v-if="isShowRejectInvoiceSection">
          <button class="button cancel" @click="isShowRejectInvoiceSection = false">ยกเลิก</button>
          <button class="button confirm" @click="handleUpdateInvoiceStatus('REJECTED')">ส่ง</button>
        </div>
      </div>

      <!-- Partner -->
      <div class="sub-title" v-else>
        <div class="text-wrapper">
          <div class="title">รายละเอียดใบแจ้งหนี้</div>
          <p style="color: #F4643A;" v-if="isRejectedStatus">* ใบแจ้งหนี้ของท่านไม่ผ่านการอนุมัติ กรุณาลบและสร้างใบแจ้งหนี้ใหม่อีกครั้ง</p>
        </div>
        <div class="button-wrapper">
          <button class="button"
            :class="isRejectedStatus ? 'rejected' : 'cancel'"
            @click="isShowDeleteInvoiceDialog = true"
            v-if="isShowDeleteInvoiceButton">
            <img :src="isRejectedStatus
              ? '/static/icons/supplier-trash-icon-white.svg'
              : '/static/icons/supplier-trash-icon-black.svg'" />ลบใบแจ้งหนี้
          </button>
          <confirm
            v-if="isShowDeleteInvoiceDialog"
            @confirm="handleDeleteInvoice"
            :data="deleteInvoiceDialog" />
          <!-- TODO: open on phase2
          <button class="button cancel ml-3">
            <img src="/static/icons/supplier-edit-icon.svg" />แก้ไข
          </button> -->
        </div>
      </div>

      <!-- Content -->
      <div class="body mt-4">

        <!-- Left -->
        <div class="left">

          <!-- Reject Invoice Form -->
          <div class="form-wrapper reject mb-4"
            v-if="isShowRejectInvoiceSection" >
            <div class="header admin">
              <div class="title admin">เหตุผลในการไม่อนุมัติ</div>
            </div>
            <div class="reject-form">
              <div class="item">
                <p>เหตุผลในการไม่อนุมัติ  <span style="color: red;">*</span></p>
                <el-select
                  id="reject-id"
                  name="reject-id"
                  v-model="rejectForm.reasonId"
                  clearable
                  placeholder="เลือกเหตุผล">
                  <el-option
                    v-for="value in rejectedReasons"
                    :key="value.id"
                    :value="value.id"
                    :label="value.message" />
                </el-select>
              </div>
              <div class="item mt-3">
                <p>รายละเอียดเพิ่มเติม</p>
                <el-input
                  id="reject-note"
                  name="reject-note" 
                  v-model="rejectForm.note"
                  type="textarea"
                  maxlength="200"
                  placeholder="ระบุรายละเอียดเพิ่มเติม"
                  autocomplete="off"
                  show-word-limit
                  clearable
                  rows="3" />
              </div>
            </div>
          </div>

          <!-- Status Info for Tablet and Mobile size -->
          <div class="status-info mb-4" v-if="isLessThanDesktopSize">
            <div class="admin-status">
              <div class="admin">
                <p>ผู้ตรวจสอบ :</p>
                <p class="value">{{ detailsResult.adminName }}</p>
              </div>
              <div class="status-wrapper" :class="statusList('background')">
                <div class="item">
                  <p class="title" v-if="isMoreThanMobileSize">สถานะ </p>
                  <p class="value status" :class="statusList('text')">{{ statusText() }}</p>
                </div>
              </div>
            </div>
            <div class="info">
              <div class="item mt-2" v-if="detailsResult.rejectedMessage">
                <p>เหตุผลในการไม่อนุมัติ :</p>
                <p class="value status-text">{{ detailsResult.rejectedMessage }}</p>
              </div>
              <div class="item mt-2" v-if="detailsResult.rejectedNote">
                <p>รายละเอียดเพิ่มเติม :</p>
                <p class="value">{{ detailsResult.rejectedNote }}</p>
              </div>
            </div>
          </div>

          <!-- Invoice -->
          <div class="form-wrapper">
            <div class="header">
              <div class="title">ใบแจ้งหนี้</div>
            </div>
            <div class="form">
              <div class="item">
                <p>เลขที่ใบแจ้งหนี้ :</p>
                <p style="font-weight: 700;">{{ detailsResult.invoiceNo }}</p>
              </div>
              <div class="item">
                <p>วันที่ในใบแจ้งหนี้ :</p>
                <p style="font-weight: 700;">{{ invoiceDate }}</p>
              </div>
              <div class="item">
                <p>จำนวนเงินรวม :</p>
                <p style="font-weight: 700;">{{ detailsResult.invoiceTotalPrice }}</p>
              </div>
            </div>
            <div class="button-wrapper view-invoice">
              <button class="button" :class="isRejectedStatus ? 'cancel' : 'confirm'" @click="openPdf(detailsResult.invoiceDocumentUrl)">
                <i class="fas fa-file-pdf" :style="isRejectedStatus ? 'color: #000000;' : 'color: #FFFFFF;'"></i>ดูใบแจ้งหนี้
              </button>
            </div>
          </div>

          <!-- Receipt -->
          <div class="form-wrapper mt-4">
            <div class="header">
              <div class="title">ใบเสร็จ</div>
            </div>
            <div class="form">
              <div class="item">
                <p>เลขที่ใบเสร็จ :</p>
                <p style="font-weight: 700;">{{ detailsResult.receiptNo }}</p>
              </div>
              <div class="item">
                <p>วันที่ในใบเสร็จ :</p>
                <p style="font-weight: 700;">{{ receiptDate }}</p>
              </div>
              <div class="item">
                <p>จำนวนเงินรวม :</p>
                <p style="font-weight: 700;">{{ detailsResult.receiptTotalPrice }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Right -->
        <div class="right">

          <!-- Status Info for Desktop -->
          <div class="status-info mb-4" v-if="isDesktopSize">
            <div class="admin-status">
              <div class="admin">
                <p>ผู้ตรวจสอบ :</p>
                <p class="value">{{ detailsResult.adminName }}</p>
              </div>
              <div class="status-wrapper" :class="statusList('background')">
                <div class="item">
                  <p class="title" v-if="isMoreThanMobileSize">สถานะ </p>
                  <p class="value status" :class="statusList('text')">{{ statusText() }}</p>
                </div>
              </div>
            </div>
            <div class="info">
              <div class="item mt-2" v-if="detailsResult.rejectedMessage">
                <p>เหตุผลในการไม่อนุมัติ :</p>
                <p class="value status-text">{{ detailsResult.rejectedMessage }}</p>
              </div>
              <div class="item mt-2" v-if="detailsResult.rejectedNote">
                <p>รายละเอียดเพิ่มเติม :</p>
                <p class="value">{{ detailsResult.rejectedNote }}</p>
              </div>
            </div>
          </div>

          <!-- Project Appointments -->
          <div class="form-wrapper" style="padding-bottom: 24px;">
            <div class="header">
              <div class="title">โครงการที่เลือก</div>
            </div>
            <div class="appointment"
              v-for="(project, projectIndex) in projectAppointments"
              :key="project.id">
              <div class="project-wrapper" @click="handleSelectProject(projectIndex)">
                <p class="name">{{ project.name }}</p>
                <div class="arrow-wrapper">
                  <div v-if="isProjectActive(projectIndex)" class="ml-2 arrow down"></div>
                  <div v-else class="ml-2 arrow up"></div>
                </div>
              </div>
              <div v-if="isProjectActive(projectIndex)">
                <div
                  v-for="(month, monthIndex) in project.months"
                  :key="month.fulfilledYearMonth">
                  <div class="month-wrapper mt-2" @click="handleSelectMonth(projectIndex, monthIndex)">
                    <p style="font-size: 14px;">{{ month.fulfilledAtThaiDateText }}</p>
                    <div class="arrow-wrapper">
                      <div v-if="isMonthActive(projectIndex, monthIndex)" class="ml-2 arrow down"></div>
                      <div v-else class="ml-2 arrow up"></div>
                    </div>
                  </div>
                  <div v-if="isMonthActive(projectIndex, monthIndex)" class="fulfilled-month">
                    <div class="header">
                      <p>บ้านเลขที่</p>
                      <p style="margin-left: auto;">{{ `${allAppointmentCount(month.homes)} ทั้งหมด` }}</p>
                    </div>
                    <div v-for="home in month.homes" :key="home.id">
                      <div class="home">
                        <p class="mb-1">{{ home.addressNo }}</p>
                        <div v-for="appointment in home.appointments" :key="appointment.id">
                          <div class="service mt-1">
                            <p>{{ `- ${appointment.serviceName}` }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <confirm
      v-if="isShowDeleteSuccessWithRejectStatus"
      @confirm="handleDeleteInvoiceSuccess"
      :data="deleteSuccessWithRejectStatusDialog" />
  </page-wrapper>
</template>

<script>
import PageWrapper from "../components/SupplierPageWrapper";
import { baanRueJaiClient } from "@/dependencies"
import { toLocaleTH } from "@/lib/dateTime";
import { DateTime } from "luxon";
import { permissionRole } from "../../lib/mapper";
import { mSize, lSize } from "../StaticVariable";

export default {
  components: { PageWrapper },
  data() {
    const rejectForm = {
      reasonId: null,
      note: null
    };

    const deleteInvoiceDialog = {
      title: " ",
      detail: "ต้องการลบใบแจ้งหนี้หรือไม่?",
      buttonCancel: "ยกเลิก",
      buttonSubmit: "ลบ"
    };

    const deleteSuccessWithRejectStatusDialog = {
      title: " ",
      detail: "ลบสำเร็จ",
      buttonCancel: "กลับหน้าหลัก",
      buttonSubmit: "สร้างใบแจ้งหนี้"
    };

    return {
      windowWidth: window.innerWidth,
      roleId: parseInt(localStorage.getItem("supplierRoleId")),
      detailsResult: null,
      activeSections: [],
      projectAppointments: [],
      rejectedReasons: [],
      rejectForm,
      deleteInvoiceDialog,
      deleteSuccessWithRejectStatusDialog,
      isShowDeleteInvoiceDialog: false,
      isShowRejectInvoiceSection: false,
      isShowDeleteSuccessWithRejectStatus: false,
    };
  },
  async created() {
    await this.setupDetail();
    await this.setupProjectAppointmentList();
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    openPdf(url) {
      window.open(url, '_blank');
    },
    async setupDetail() {
      this.detailsResult = await this.fetchInvoiceDetails(this.invoiceId);

      if (this.isRuejaiPartnerAdmin && !this.isRejectedStatus) await this.setupRejectedReasonList();
    },
    async setupRejectedReasonList() {
      this.rejectedReasons = await this.fetchAdminRejectedReasonList(this.invoiceId);
    },
    async setupProjectAppointmentList() {
      const projectAppointments = await this.fetchProjectAppointmentList(this.invoiceId);

      this.projectAppointments = projectAppointments;

      if (this.projectAppointments) await this.setupActiveSections();
    },
    async setupActiveSections() {
      this.activeSections = this.projectAppointments.map((project, projectIndex) => {
        const isLastProject = this.projectAppointments.length - 1 === projectIndex;

        return {
          isProjectActive: isLastProject,
          months: project.months.map((_, monthIndex) => {
            const activeMonth = this.activeSections
              && this.activeSections[projectIndex]
              && this.activeSections[projectIndex].months
              && this.activeSections[projectIndex].months[monthIndex]
              ? this.activeSections[projectIndex].months[monthIndex] : undefined;

            const isMonthActive = activeMonth ? activeMonth.isMonthActive : true;

            return { isMonthActive: isMonthActive };
          })
        };
      });

      this.projectId = null;
    },
    handleSelectProject(index) {
      this.activeSections[index].isProjectActive = !this.isProjectActive(index);
    },
    handleSelectMonth(projectIndex, monthIndex) {
      this.activeSections[projectIndex].months[monthIndex].isMonthActive
        = !this.isMonthActive(projectIndex, monthIndex);
    },
    async handleDeleteInvoice(isConfirm) {
      if (!isConfirm) {
        this.isShowDeleteInvoiceDialog = false;
        return;
      }

      try {
        // Delete invoice
        await this.deleteInvoice(this.invoiceId);

        if (this.isRejectedStatus) {
          // Hide delete invoice dialog
          this.isShowDeleteInvoiceDialog = false;

          // Show delete success dialog
          this.isShowDeleteSuccessWithRejectStatus = true;
        } else {
          this.navigateToDashboardPage(this.status);
        }
      } catch (error) {
        alert("ลบใบแจ้งหนี้ไม่สำเร็จ");
      }
    },
    handleDeleteInvoiceSuccess(isConfirm) {
      // Hide delete success dialog
      this.isShowDeleteSuccessWithRejectStatus = false;

      this.navigateToDashboardPage('un_billed');
      if (isConfirm) this.navigateToCreateInvoicePage();
    },
    async handleUpdateInvoiceStatus(status) {
      try {
        // Set default params
        let params = { status: status };

        // Validate if status is REJECTED
        const isRejectedStatus = status === "REJECTED";

        if (isRejectedStatus) {
          // Get reject form data
          const {
            reasonId,
            note
          } = this.rejectForm;

          // Validate if reasonId is empty
          if (!reasonId) {
            alert("กรุณาเลือกเหตุผลในการไม่อนุมัติ");
            return;
          }

          // Set params
          params = {
            ...params,
            rejected_reason_id: reasonId,
            rejected_note: note
          };
        }

        // Update invoice status
        await this.updateInvoiceStatus(this.invoiceId, params);
        await this.setupDetail();

        // Reset reject form
        this.isShowRejectInvoiceSection = false;
      } catch (error) {
        alert("อัพเดทสถานะใบแจ้งหนี้ไม่สำเร็จ");
      }
    },
    allAppointmentCount(homes) {
      return homes.reduce((acc, home) => acc + home.appointments.length, 0);
    },
    dateTimeTH(dateTime) {
      if (!dateTime) return;

      return toLocaleTH(DateTime.fromISO(dateTime)).toFormat("dd MMM yyyy");
    },
    statusList(prefix) {
      return this.detailsResult ? `${prefix}_${this.detailsResult.status.toLowerCase()}` : "";
    },
    statusText() {
      const status = this.detailsResult.status;

      if (status === "PENDING") {
        return "รอตรวจสอบ";
      } else if (status === "REJECTED") {
        return "ไม่อนุมัติ";
      } else if (status === "DOCUMENT_APPROVED") {
        return "เอกสารผ่าน";
      } else if (status === "PAYMENT_APPROVED") {
        return "อนุมัติ";
      } else if (status === "TRANSFERRED") {
        return "เสร็จสิ้น";
      } else {
        return "-";
      }
    },
    clearInvoiceFileRef() {
      this.$refs.invoiceFileRef.value = "";
    },
    clearReceiptFileRef() {
      this.$refs.receiptFileRef.value = "";
    },
    selectInvoiceFile() {
      this.$refs.invoiceFileRef.click();
    },
    selectReceiptFile() {
      this.$refs.receiptFileRef.click();
    },
    navigateToCreateInvoicePage() {
      this.$router.push({ name: "SupplierCreateInvoice" });
    },
    navigateToDashboardPage(status) {
      this.$router.replace({
        name: 'SupplierInvoiceDashboard',
        query: { status: status }
      });
    },
    isProjectActive(index) {
      return this.activeSections[index].isProjectActive;
    }, 
    isMonthActive(projectIndex, monthIndex) {
      return this.activeSections[projectIndex].months[monthIndex].isMonthActive;
    },
    async fetchInvoiceDetails(id) {
      return await baanRueJaiClient.others.supplier.getInvoiceDetails(id);
    },
    async fetchProjectAppointmentList(id) {
      return await baanRueJaiClient.others.supplier.getProjectAppointmentListByInvoiceId(id);
    },
    async fetchAdminRejectedReasonList(id) {
      return await baanRueJaiClient.others.supplier.getRuejaiPartnerAdminRejectedReasonList(id);
    },
    async deleteInvoice(id) {
      return await baanRueJaiClient.others.supplier.deleteInvoice(id);
    },
    async updateInvoiceStatus(id, params) {
      return await baanRueJaiClient.others.supplier.updateInvoiceStatus(id, params);
    }
  },
  computed: {
    invoiceId() {
      return this.$route.params.invoiceId;
    },
    invoiceDate() {
      return this.detailsResult ? this.dateTimeTH(this.detailsResult.invoiceDate) : "-";
    },
    receiptDate() {
      return this.detailsResult && this.detailsResult.receiptDate
        ? this.dateTimeTH(this.detailsResult.receiptDate) : "-";
    },
    status() {
      return this.$route.params.status;
    },
    isShowDetails() {
      return this.detailsResult && this.projectAppointments.length > 0;
    },
    isRuejaiPartnerAdmin() {
      return this.roleId === permissionRole.RJPADMIN;
    },
    isPendingStatus() {
      return this.detailsResult.status === "PENDING";
    },
    isRejectedStatus() {
      return this.detailsResult.status === "REJECTED";
    },
    isTransferredStatus() {
      return this.detailsResult.status === "TRANSFERRED";
    },
    isShowAdminButtonSection() {
      return !this.isTransferredStatus && !this.isRejectedStatus && !this.isShowRejectInvoiceSection;
    },
    isShowDeleteInvoiceButton() {
      return this.isPendingStatus || this.isRejectedStatus;
    },
    isMoreThanMobileSize() {
      return this.windowWidth >= mSize;
    },
    isLessThanDesktopSize() {
      return this.windowWidth < lSize - 1;
    },
    isDesktopSize() {
      return this.windowWidth >= lSize;
    },
    updateStatusButtonText() {
      const status = this.detailsResult.status;

      if (status === "PENDING") return "เอกสารผ่าน";
      if (status === "DOCUMENT_APPROVED") return "อนุมัติ";
      if (status === "PAYMENT_APPROVED") return "เสร็จสิ้น";
    },
    invoiceStatus() {
      const status = this.detailsResult.status;

      if (status === "PENDING") return "DOCUMENT_APPROVED";
      if (status === "DOCUMENT_APPROVED") return "PAYMENT_APPROVED";
      if (status === "PAYMENT_APPROVED") return "TRANSFERRED";
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
.content-wrapper {
  display: flex;
  flex-direction: column;
}

.sub-title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid $color-light-gray-1;

  .text-wrapper {
    display: flex;
    flex-direction: column;

    > .title {
      font-size: 24px;
      font-weight: 700;
    }

    > .provider {
      font-size: 16px;
      color: #808080;
    }
  }
}

.status-info {
  display: flex;
  flex-direction: column;
  padding: 24px;
  border: 1px solid $color-light-gray-1;
  border-radius: 8px;

  .admin-status {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .admin {
      display: flex;
      flex-direction: column;
    }

    .status-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      padding-inline: 16px;
      padding-block: 8px;

      .item {
        display: flex;
        flex-direction: row;
        align-items: end;

        .title {
          font-size: 14px;
          margin-right: 8px;
        }

        .status {
          font-size: 18px;
          line-height: 1.6;
        }

        .text_pending,
        .text_document_approved,
        .text_payment_approved,
        .text_transferred {
          color: #5175E1;
        }

        .text_rejected {
          color: #F4643A;
        }
      }
    }
  }

  .info {
    display: flex;
    flex-direction: column;

    .item {
      display: flex;
      flex-direction: column;

      .status-text {
        color: #F4643A;
      }
    }
  }

  p {
    font-size: 16px;
  }

  .value {
    font-weight: 700;
  }

  .background_pending,
  .background_document_approved,
  .background_payment_approved,
  .background_transferred {
    background: #5175E11A;
  }

  .background_rejected {
    background: #F4643A1A;
  }
}

.body {
  width: 100%;
  display: grid;
  grid-template-columns: calc(60% - 10px) calc(40% - 10px);
  grid-gap: 20px;
  padding-inline: 24px;
  padding-bottom: 32px;

  .header {
    display: flex;
    flex-direction: column;
    padding: 16px 24px;
    background-color: #0000000A;

    > .title {
      font-size: 18px;
      font-weight: 700;
    }

    .title.admin {
      color: #5175e1;
    }

    > .value {
      font-size: 14px;
    }
  }

  .header.admin {
    background-color: #5175e11a;
  }

  .form-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    border: 1px solid $color-light-gray-1;
    border-radius: 8px;
  }

  .form-wrapper.reject {
    border: 2px solid #5175e1;
  }

  .left {
    .form {
      z-index: 2;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 16px;
      padding: 24px;

      .item {
        display: flex;
        flex-direction: column;
      }
    }

    .reject-form {
      display: flex;
      flex-direction: column;
      padding: 24px;

      .item {
        display: flex;
        flex-direction: column;
      }
    }

    .preview-invoice {
      z-index: 1;
      position: relative;
      width: 100%;
      padding: 0 24px;

      .display-file {
        height: 360px;
        border-radius: 8px;
      }
    }

    .rejected-item {
      display: flex;
      flex-direction: column;
    }

    p {
      font-size: 16px;
    }
  }

  .right {
    display: flex;
    flex-direction: column;

    .appointment {
      display: flex;
      flex-direction: column;
      padding: 0 24px 0 24px;

      .project-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 16px 0 8px 0;
        border-bottom: 1px solid $color-light-gray-1;
        cursor: pointer;

        .name {
          font-size: 18px;
          font-weight: 700;
        }
      }

      .month-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
        padding-bottom: 8px;
      }

      .arrow-wrapper {
        margin-left: auto;
        padding: 4px;

        .arrow {
          width: 8px;
          height: 8px;
          border: solid $black;
          border-width: 0 1.5px 1.5px 0;
          display: inline-block;
        }

        > .up {
          transform: rotate(-135deg);
          -webkit-transform: rotate(-135deg);
        }

        > .down {
          transform: rotate(45deg);
          -webkit-transform: rotate(45deg);
        }
      }

      .fulfilled-month {
        display: flex;
        flex-direction: column;
        border: 1px solid #d9d9d9;

        .header {
          display: flex;
          flex-direction: row;
          align-items: center;
          background: #F7F7F7;
          padding: 8px 24px;
          border-bottom: 1px solid #d9d9d9;

          p {
            font-size: 14px;
            color: #808080;
          }
        }

        .home {
          display: flex;
          flex-direction: column;
          padding: 16px 24px;
          border-bottom: 1px solid #d9d9d9;

          p {
            font-weight: 700;
          }

          .service {
            display: flex;
            flex-direction: row;

            p {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}

.button {
  width: 168px;
  height: 44px;
  font-weight: bold;
  font-size: $font-16;
  border-radius: 8px;
  margin-right: auto;

  img {
    margin-right: 8px;
  }

  i {
    margin-right: 8px;
  }
}

.cancel {
  color: $black;
  background: transparent;
  border: 1px solid $color-light-gray-1;

  &:hover:not(:disabled) {
    background: $color-light-gray-1-hover;
  }
}

.rejected {
  color: $white;
  background: #F4643A;
  border: 0;

  &:hover:not(:disabled) {
    background: #bb4d2bd3;
  }
}

.confirm {
  color: $black;
  background: #5175E1;
  color: white;
  border: 0;

  &:hover:not(:disabled) {
    background: rgba(81, 117, 225, 0.8);
  }
}

.button-wrapper {
  display: flex;
}

.button-wrapper.admin {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 16px;
}

.button-wrapper.view-invoice {
  margin-left: 24px;
  margin-bottom: 24px;
}

@media (max-width: ($m-size - 1)) {
  .sub-title {
    padding: 16px;

    .text-wrapper {
      > .title {
        font-size: 16px;
      }

      > .provider {
        font-size: 14px;
      }
    }
  }

  .sub-title.admin {
    flex-direction: column;
    align-items: start;
    grid-gap: 16px;
  }

  .status-info {
    padding: 16px;

    .admin-status {
      .status-wrapper {
        padding-inline: 8px;
        padding-block: 4px;

        .item {
          .status {
            font-size: 16px;
          }
        }
      }
    }
  }

  .body {
    display: flex;
    flex-direction: column;
    padding-inline: 20px;
    padding-bottom: 24px;

    .header {
      padding: 16px;

      > .title {
        font-size: 13px;
      }

      > .value {
        font-size: 12px;
      }
    }

    .left {
      .form {
        grid-gap: 8px;
        padding: 16px;
      }

      .preview-pdf {
        padding: 0 16px;
      }

      p {
        font-size: 13px;
      }
    }

    .right {
      .appointment {
        padding: 0 16px 16px 16px;

        .project-wrapper {
          .name {
            font-size: 13px;
          }
        }

        .fulfilled-month {
          .header {
            padding: 8px 16px;

            p {
              font-size: 13px;
            }
          }

          .home {
            padding: 16px;

            p {
              font-size: 13px;
            }

            .service {
              p {
                font-size: 13px;
                margin-left: 8px;
              }
            }
          }
        }
      }
    }
  }

  .button {
    width: 100%;
    height: 40px;
    font-size: $font-14;

    img {
      width: 14px;
    }
  }

  .button-wrapper.admin {
    width: 100%;
  }

  .button-wrapper.view-invoice {
    width: 130px;
    margin-left: 16px;
    margin-bottom: 16px;
  }
}

@media (min-width: $m-size) and (max-width: ($ml-size - 1)) {
  .sub-title {
    padding: 16px;

    .text-wrapper {
      > .title {
        font-size: 18px;
      }

      > .provider {
        font-size: 14px;
      }
    }
  }

  .status-info {
    padding: 16px;

    .admin-status {
      .status-wrapper {
        padding-inline: 12px;
        padding-block: 6px;

        .item {
          .title {
            font-size: 12px;
          }

          .status {
            font-size: 16px;
          }
        }
      }
    }

    p {
      font-size: 14px;
    }
  }

  .body {
    display: flex;
    flex-direction: column;
    padding-inline: 16px;
    padding-bottom: 24px;

    .header {
      padding: 16px 20px;

      > .title {
        font-size: 16px;
      }

      > .value {
        font-size: 13px;
      }
    }

    .left {
      .form {
        grid-gap: 8px;
        padding: 16px;
      }

      .preview-pdf {
        padding: 0 16px;
      }
    }

    .right {
      .appointment {
        padding: 0 16px 20px 16px;

        .fulfilled-month {
          .header {
            padding: 8px 16px;
          }

          .home {
            padding: 16px;

            .service {
              p {
                margin-left: 8px;
              }
            }
          }
        }
      }
    }
  }

  .button {
    width: 145px;
    height: 40px;
    font-size: $font-14;

    img {
      width: 14px;
    }
  }

  .button-wrapper.view-invoice {
    margin-left: 16px;
    margin-bottom: 16px;
  }
}

@media (min-width: $ml-size) and (max-width: ($l-size - 1)) {
  .sub-title {
    padding: 16px 20px;

    .text-wrapper {
      > .title {
        font-size: 20px;
      }

      > .provider {
        font-size: 16px;
      }
    }
  }

  .status-info {
    padding: 20px;
  }

  .body {
    display: flex;
    flex-direction: column;
    padding-inline: 20px;
    padding-bottom: 24px;

    .header {
      padding: 16px 20px;
    }

    .left {
      .form {
        grid-gap: 16px;
        padding: 24px;

        .item {
          display: flex;
          flex-direction: column;
        }
      }
    }
  }

  .button {
    width: 160px;
    height: 40px;
    font-size: $font-16;

    img {
      width: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/other-web/supplier/pages/InvoiceDetail.vue